module.exports = __webpack_public_path__ + "media/img/corporate/team-4b98045b57c48e300a99bd841dcddb8f.jpg";